import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'
import { ToastContainer, notify } from '../../libraries/notifications';
import { optionSelectGenerator, composeValidators, validateEmail, validateIsfilled, getObjectWithJsonDataToFormValues, getTimeZone, dateComponents, validateOnlyNumber, capitalize, isDate, formatOnlyNumberInput, months } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';
import SelectInput from '../../components/forms/SelectInput';
import MultiSelectInput from '../../components/forms/MultiSelectInput';
import SelectSearchInput from '../../components/forms/SelectSearchInput';
import DatepickerInput from '../../components/forms/DatepickerInput';
import DatepickerInputCalendar from '../../components/forms/DatepickerInputCalendar';

import insurancesActions from '../../context/insurances/actions';
import userActions from '../../context/users/actions';
import filesActions from '../../context/files/actions';

import { zonedTimeToUtc } from 'date-fns-tz';
import Icon from '../../libraries/icons';

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      selectedFile: null,
      profile_image: null,
      user: null,
      insurances: [],
      loading: true,
    }
  }

  componentDidMount() {
    console.log('USER INFO PAGE', this.props.auth.user);
    this.getData()
  }

  getData = async () => {
    await this.getInsurances();
    this.getUser();
  }
  getUser = async () => {
    console.log('GETTING USER');
    await this.props.onGetUser({ id: this.props.auth.user.id });
    console.log('AFTER GET');
    const error = this.props.user.error;
    if (error) {
      notify(this.t(error.message));
    } else {
      const user = getObjectWithJsonDataToFormValues(this.props.user.item, ['id', 'first_name', 'last_name', 'phone', 'email', 'profile_image', 'identification', 'identification_type', 'gender', 'birth_date', 'insurance', 'insurance_number', 'verified']);
      let user_bd = new Date(user.birth_date)
      user.birthdate_day = user_bd.getDate()
      user.birthdate_month = user_bd.getMonth() + 1
      user.birthdate_year = user_bd.getFullYear()

      const ins = this.state.insurances.find(insurance => insurance.rnos === user.insurance)
      if (ins) {
        user.insurance = [{ value: user.insurance, label: ins.name }]
      } else {
        user.insurance = []
      }
      
      this.setState({ user, loading: false });
    }
  }


  getInsurances = async () => {
    await this.props.onGetAllInsurances();
    const { insurances } = this.props;
    if (insurances.error) {
      notify(this.t(insurances.error.message));
    } else {
      this.setState({ insurances: insurances.items });
    }
  }


  gotoBack = async () => {
    // await this.props.onGetToken();
    // if (this.props.auth.error) notify(this.t(this.props.auth.error.message));
    history.push(config.ROUTES.USER.PROFILE);
  }

  onSubmit = async values => {
    this.setState({ submitting: true });
    const data = { ...values, user_type: config.USER_TYPE.PATIENT }

    if (values.insurance.length) data.insurance = values.insurance[0].value
    //console.log(data.insurance, this.state.insurances.find(x => x.id === data.insurance))
    data.insurance = this.state.insurances.find(x => x.id === data.insurance)?.rnos //FIXME: que es rnos???

    //data.birth_date = dateComponents(values.birth_date)[3].dateOnly
    let month = values.birthdate_month - 1
    data.birth_date = new Date(values.birthdate_year, month, values.birthdate_day)
    console.log("bd day", values.birthdate_day, data.birth_date.getDate(), data.birth_date)
    if (values.birthdate_day.toString() !== data.birth_date.getDate().toString()) {
      notify(this.t("Ingrese una fecha válida"));
      this.setState({ submitting: false });
      return
    }

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDate = zonedTimeToUtc(data.birth_date, timeZone)
    data.birth_date = utcDate

    delete data.email
    delete data.birthdate_year
    delete data.birthdate_month
    delete data.birthdate_day
    if(data.verified){
      delete data.verified
    }

    //return
    await this.props.onUpdate(data);
    console.log('AFTER UPDATE');
    const error = this.props.user.error;
    if (error) {
      this.setState({ submitting: false });
      notify(this.t(error.message));
    } else {
      this.gotoBack();
    }
  }

  onFileChange = async event => {
    this.setState({ submitting: true });
    console.log('ON FILE CHANGE');
    this.setState({ selectedFile: event.target.files[0] });
    await this.onFileUpload(event.target.files[0]);
    console.log('ON FILE CHANGE FINISH');
    this.setState({ submitting: false });
  }

  onFileUpload = async (file) => {
    console.log('FILE', file.name, file.type);
    const formData = new FormData();
    formData.append(
      "myFile",
      file,
      file.name
    )
    await this.props.onPictureUpload(formData);
    console.log('FILES', this.props.files);
    const error = this.props.files.error;
    if (error) {
      notify(this.t(error.message));
    } else {
      this.setState({ profile_image: this.props.files.files.fileInfo.location });
      this.props.onUpdate({ id: this.state.user.id, user_type: config.USER_TYPE.PATIENT, profile_image: this.props.files.files.fileInfo.location }).then(() => {
        console.log('AFTER SAVE PICTURE');
        const error = this.props.user.error;
        if (error) notify(this.t(error.message));
      });
    }
  }

  render() {
    const { user, profile_image, insurances } = this.state;
    
    if (profile_image) {
      console.log('AVATAR UPLOADED');
      user.profile_image = profile_image;
    }
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    const required_date = value => {
      return (isDate(value) || new Date(value)) ? undefined : this.t("This field is required")
    }
    const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))
    const onlynumber = value => (validateOnlyNumber(value) ? undefined : this.t("El documento solo debe llevar digitos"))
    const dnilength = value => (value.length >= 7 && value.length <= 8 ? undefined : this.t("El documento debe tener 7 u 8 numeros"))

    const dni_types = optionSelectGenerator(config.OPTIONS.SINGUP.IDENTIFICATION.TYPES, (v) => this.t(v));
    const gender_types = optionSelectGenerator(config.OPTIONS.SINGUP.GENDER.TYPES, (v) => capitalize(v));
    const insurances_list = insurances.map((o) => { return { value: o.rnos, label: o.name } });

    const today = new Date()
    let years = [...Array(today.getFullYear() + 1).keys()].slice(1915, today.getFullYear() + 1).map(x => { return { label: x, value: x } })
    years.reverse()
    const months_arr = [...Array(13).keys()].slice(1, 13).map(x => { return { label: capitalize(months(x - 1).slice(0, 3)), value: x } })
    const days = [...Array(32).keys()].slice(1, 32).map(x => { return { label: x, value: x } })
    return (
      <LayoutSmall
        main={{ className: "" }}
        header={{
          className: "",
          left: { icon: 'arrow_left', action: () => this.gotoBack() }
        }}
        loading={this.state.loading}
        container={{ className: "px-0" }}
      >
        <ToastContainer />
        <section className="bg-primary text-center px-3 pt-2 pb-8">
          <div className="center mx-auto">
            <div className="px-4 py-3 rounded-lg text-center">
              <div className="rounded-full bg-primary-focus overflow-hidden flex items-center text-center m-auto w-28 h-28">
                {user && user.profile_image ? (
                  <img className="w-full h-auto" src={user && user.profile_image} alt="" />
                ) : (
                  <span className="m-auto text-white text-2xl">{user && user.name}</span>
                )}
              </div>
              <label className="cursor-pointer mt-6">
                <span className="btn btn-secondary btn-sm mt-3">{this.t("Upload a photo")}</span>
                <input type='file' className="hidden" multiple="multiple" accept="accept" onChange={this.onFileChange} />
              </label>
            </div>
          </div>
        </section>
        <section className="px-4 -mt-5 text-base-content">
          <Form
            initialValues={user || {}}
            onSubmit={this.onSubmit}
          >
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                <div className="card white p-4 mb-6">
                  {(!user?.verified || user?.verified !== "verified") &&
                    <div className="flex items-center mb-3">
                      <div className="w-2/3" >
                        <div className="flex items-center gap-2">
                          <Icon className="text-primary w-8 h-8" name="exclamation" />
                          <p>No verificado</p>
                        </div>
                      </div>
                      <div className="w-1/3" >
                        <Button
                          className="btn-sm btn-primary btn-block"
                          title={this.t("Verificar")}
                          onClick={() => { history.push({pathname: config.ROUTES.SIGNUP_VERIFICATION2, state: {identification:user.identification, identification_type:user.identification_type}}) }}
                          disabled={this.state.submitting}
                        />
                      </div>

                    </div>}
                  {user?.verified === "verified" && <div className="flex mb-3 gap-2 items-center">
                    <Icon className="text-success w-7 h-7" name="checkmark_outline" />
                    <p>Verificado</p>
                  </div>
                  }
                  <div className="w-full mb-3 md:mb-0">
                    <Field name="first_name" component={TextInput} placeholder={this.t("First name")} label={this.t("First name")}
                      validate={required}
                      readOnly={user?.verified === "verified"}
                      inputClassName="input-bordered shadow-none"
                    />
                  </div>
                  <div className="w-full mb-3 md:mb-0">
                    <Field name="last_name" component={TextInput} placeholder={this.t("Last name")} label={this.t("Last name")}
                      validate={required}
                      readOnly={user?.verified === "verified"}
                      inputClassName="input-bordered shadow-none"
                    />
                  </div>
                  <div className="flex mb-3">
                    <div className="w-1/3 mr-4">
                      <Field name="identification_type" component={SelectInput} placeholder={this.t("Tipo de Doc")}
                        options={dni_types} label={this.t("Tipo")}
                        empty={this.t("Seleccione")} validate={required}
                        inputClassName="input-bordered shadow-none"
                        readOnly={user?.verified === "verified"}
                      />
                    </div>
                    <div className="w-2/3">
                      <Field
                        name="identification"
                        parse={v => formatOnlyNumberInput(v, 8)}
                        component={TextInput}
                        placeholder={this.t("8 dígitos")}
                        label={this.t("Nro de Documento")}
                        validate={composeValidators(required, onlynumber, dnilength)}
                        inputClassName="input-bordered shadow-none"
                        readOnly={user?.verified === "verified"}
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-20 mr-2">
                      <Field
                        name="birthdate_day"
                        label={this.t("Fecha de nacimiento")}
                        component={SelectInput}
                        options={days}
                        validate={required}
                        readOnly={user?.verified === "verified"}
                        inputClassName="input-bordered shadow-none"
                        labelClassName="w-32"
                      />
                    </div>
                    <div className="w-32 mr-2 pt-9">
                      <Field
                        name="birthdate_month"
                        component={SelectInput}
                        options={months_arr}
                        validate={required}
                        readOnly={user?.verified === "verified"}
                        inputClassName="input-bordered shadow-none"
                      />
                    </div>
                    <div className="w-32 mr-2 pt-9">
                      <Field
                        name="birthdate_year"
                        component={SelectInput}
                        options={years}
                        validate={required}
                        readOnly={user?.verified === "verified"}
                        inputClassName="input-bordered shadow-none"
                      />
                    </div>
                  </div>

                  <div className="flex mb-3">
                    <div className="w-1/2 mr-4">
                      <Field
                        name="gender"
                        component={SelectInput}
                        placeholder={this.t("Genero")}
                        options={gender_types}
                        label={this.t("Género")}
                        empty={this.t("Seleccione")}
                        validate={required}
                        readOnly={user?.verified === "verified"}
                        inputClassName="input-bordered shadow-none"
                      />
                    </div>
                  </div>
                  <div className="w-full mb-3">
                    <Field
                      name="email"
                      component={TextInput}
                      placeholder={this.t("Ej. mail@mail.com")}
                      label={this.t("Correo electrónico")}
                      readOnly={true}
                      inputClassName="input-bordered shadow-none"
                    />
                  </div>
                  <div className="w-full mb-3 md:mb-0">
                    <Field name="phone" parse={v => formatOnlyNumberInput(v, 11)} component={TextInput} placeholder={this.t("Phone number")} label={this.t("Phone number")}
                      validate={required}
                      inputClassName="input-bordered shadow-none"
                    />
                  </div>

                  <div className="w-full">
                    <Field
                      name="insurance"
                      component={MultiSelectInput}
                      label={this.t("Obra Social")}
                      placeholder={this.t("Obra Social")}
                      options={insurances_list}
                      empty={this.t("Seleccione")} validate={required}
                      inputClassName="input-bordered shadow-none"
                      disableSelectAll={true}
                      single={true}
                    />
                  </div>
                  <div className="w-full">
                    <Field
                      name="insurance_number"
                      component={TextInput}
                      placeholder={this.t("Nro. de Socio")}
                      label={this.t("Nro. de Socio")}
                      validate={composeValidators(required)}
                      inputClassName="input-bordered shadow-none"
                    />
                  </div>

                  

                  <div className="w-full mb-4">
                    <Button
                      className="btn-primary btn-block"
                      title={this.t("Save")}
                      onClick={handleSubmit}
                      disabled={this.state.submitting || pristine}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>
        </section>
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    files: state.files,
    user: state.users.current,
    insurances: state.insurances.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdate: (params) => dispatch(userActions.saveOrUpdate(params)),
    onGetUser: (params) => dispatch(userActions.get(params)),
    onPictureUpload: (params) => dispatch(filesActions.upload(params)),
    onGetToken: () => dispatch(userActions.getFromToken()),
    onGetAllInsurances: (params) => dispatch(insurancesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(UserInfo));
